import React, { useState } from "react";
import { useAppDispatch } from "../../utils/redux/hooks";
import { nanoid } from "@reduxjs/toolkit";
import { PostData, postAdded } from "./postSlice";

const AddPostForm = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const dispatch = useAppDispatch();

  const onTitleChanged = (e: React.ChangeEvent<HTMLInputElement>) =>
    setTitle(e.target.value);
  const onContentChanged = (e: React.ChangeEvent<HTMLInputElement>) =>
    setContent(e.target.value);

  const onSavePostClicked = (event: React.MouseEvent) => {
    event.preventDefault();
    if (title && content) {
      const dataToDispatch: PostData = {
        id: nanoid(),
        title: title,
        content: content,
      };
      dispatch(postAdded(dataToDispatch));

      setTitle("");
      setContent("");
    }
  };

  return (
    <div className="  flex justify-center items-center  ">
      <div className="bg-purple-400 shadow-2xl dark:bg-purple-900 rounded-lg p-6 mt-5">
        <h1 className="text-xl font-bold">Add a New Post</h1>
        <form className="p-4 flex flex-col  gap-2">
          <label className="">
            Post Title:{" "}
            <input
              className="bg-gray-200 dark:bg-gray-600 rounded-md ml-2 pl-2"
              type="text"
              id="postTitle"
              name="postTitle"
              value={title}
              onChange={onTitleChanged}
            />
          </label>
          <label>
            Content:{" "}
            <input
              className="bg-gray-200 dark:bg-gray-600 rounded-md ml-2 pl-2"
              type="text"
              id="postContent"
              name="postContent"
              value={content}
              onChange={onContentChanged}
            />
          </label>
          <button
            className="drop-shadow-xl ease-in-out duration-300 hover:bg-indigo-500 active:bg-indigo-50 bg-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto py-3  transition "
            onClick={onSavePostClicked}
          >
            Save Post
          </button>
        </form>
      </div>
    </div>
  );
};
export default AddPostForm;
